import findIndex from 'lodash/findIndex';

import {TIME_SLOTS} from './config';

export function timestampToTimeSlot(timestamp, end = 'from') {
	return timestamp
		? findIndex(
				TIME_SLOTS,
				({from, to}) =>
					(!from || from <= timestamp) && (!to || to >= timestamp)
		  )
		: end === 'from'
		? 0
		: TIME_SLOTS.length - 1;
}

export function timeSlotToTimestamp(timeSlot, end = 'from') {
	return TIME_SLOTS[timeSlot][end] || null;
}

export function normalizeTagName(tagName) {
	return encodeURIComponent(tagName.trim().toLowerCase());
}
